import { useState } from 'react';
import './Contact.css';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    const mailto = `mailto:yazidi.khansa@gmail.com?subject=${encodeURIComponent(form.subject || 'Demande de contact')}&body=${encodeURIComponent(
      `Nom: ${form.name}\nEmail: ${form.email}\nTéléphone: ${form.phone}\n\n${form.message}`
    )}`;
    window.location.href = mailto;
    setSent(true);
  };

  return (
    <main className="contact">
      {/* Banner */}
      <div className="contact__banner">
        <div className="contact__banner-content">
          <span className="section-label">Restons en Contact</span>
          <h1 className="contact__banner-title">Contact</h1>
          <div className="contact__banner-divider" />
        </div>
      </div>

      <div className="contact__body">
        {/* Info Column */}
        <div className="contact__info">
          <div className="contact__info-block">
            <h3 className="contact__info-title">Showroom</h3>
            <p>87 Avenue Habib Bourguiba</p>
            <p>Ez-Zahra 2034, Tunisie</p>
          </div>
          <div className="contact__info-block">
            <h3 className="contact__info-title">Email</h3>
            <a href="mailto:yazidi.khansa@gmail.com">yazidi.khansa@gmail.com</a>
          </div>
          <div className="contact__info-block">
            <h3 className="contact__info-title">Téléphone</h3>
            <a href="tel:+21652428501">+216 52 428 501</a>
          </div>
          <div className="contact__info-block">
            <h3 className="contact__info-title">Horaires</h3>
            <p>Lundi – Samedi</p>
            <p>9h00 – 18h00</p>
          </div>
          <div className="contact__info-block">
            <h3 className="contact__info-title">Réseaux</h3>
            <div className="contact__socials">
              <a href="https://instagram.com/yazidikhansa/" target="_blank" rel="noreferrer">Instagram</a>
              <a href="https://facebook.com/yazidikhansa/" target="_blank" rel="noreferrer">Facebook</a>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="contact__form-wrap">
          {sent ? (
            <div className="contact__success">
              <span className="section-label">Merci !</span>
              <h2 className="contact__success-title">Message Envoyé</h2>
              <p>Nous vous répondrons dans les meilleurs délais.</p>
            </div>
          ) : (
            <form className="contact__form" onSubmit={handleSubmit}>
              <h2 className="contact__form-title">Demande de Devis</h2>
              <div className="contact__form-divider" />
              <div className="contact__row">
                <div className="contact__field">
                  <label>Nom & Prénom *</label>
                  <input name="name" value={form.name} onChange={handleChange} required placeholder="Votre nom" />
                </div>
                <div className="contact__field">
                  <label>Email *</label>
                  <input name="email" type="email" value={form.email} onChange={handleChange} required placeholder="votre@email.com" />
                </div>
              </div>
              <div className="contact__row">
                <div className="contact__field">
                  <label>Téléphone</label>
                  <input name="phone" value={form.phone} onChange={handleChange} placeholder="+216 XX XXX XXX" />
                </div>
                <div className="contact__field">
                  <label>Objet</label>
                  <input name="subject" value={form.subject} onChange={handleChange} placeholder="Demande de devis / Information..." />
                </div>
              </div>
              <div className="contact__field contact__field--full">
                <label>Message *</label>
                <textarea name="message" value={form.message} onChange={handleChange} required rows={6} placeholder="Décrivez votre projet, les produits souhaités..." />
              </div>
              <button type="submit" className="contact__submit">
                Envoyer le Message
              </button>
            </form>
          )}
        </div>
      </div>
    </main>
  );
}
